import { Skeleton } from '../ui/skeleton';
import { Avatar, AvatarFallback, AvatarImage } from '@/client/components/ui/avatar';
import { cn } from '@/client/utils';
import { api } from '@/client/utils/api';
import { usePreloadImage } from '@/libs/react-sdk/api/use-preload-Image';
import { useMemo } from 'react';

const getDiceBearUrl = (seed: string) =>
  `https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(seed)}`;

export type UserAvatarProps = {
  avatar?: string;
  address?: string;
  fallback?: string;
  className?: string;
  onClick?: () => void;
};

export const UserAvatar = ({ address, avatar, fallback, className, onClick }: UserAvatarProps) => {
  const { data: avatarUrl, isLoading } = usePreloadImage(api, avatar);
  const addressUrl = useMemo(
    () => (!avatar && !avatarUrl && address ? getDiceBearUrl(address) : ''),
    [address, avatar, avatarUrl]
  );
  const src = useMemo(() => avatarUrl || addressUrl, [addressUrl, avatarUrl]);
  if (isLoading) return <Skeleton className={cn('size-6 rounded-full', className)} />;
  return (
    <Avatar onClick={onClick} className={cn('size-6 flex-shrink-0', className)}>
      <AvatarImage loading="lazy" src={src} className="size-full object-cover" alt={fallback || address || 'avatar'} />
      <AvatarFallback>{fallback}</AvatarFallback>
    </Avatar>
  );
};
